import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { APIProvider } from '@vis.gl/react-google-maps';
import SearchField from './SearchField';
import SearchResults from './SearchResults';

SearchWrapper.propTypes = {
    defaultAddressValue: PropTypes.object,
    defaultRadiusValue: PropTypes.number,
    services: PropTypes.string,
    selectedClinic: PropTypes.string,
};

const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? 'AIzaSyDKR2D-xrjNTAS-Ug5cL78tV5uwTkcIK0w';

export default function SearchWrapper({
    defaultAddressValue = {},
    defaultRadiusValue = 50,
    services = '',
    selectedClinic = '',
}) {
    const [selectedAddress, setSelectedAddress] = useState(defaultAddressValue);
    const [radius, setRadius] = useState(defaultRadiusValue);
    const [clinicData, setClinicData] = useState(null);

    const onSelectAddress = (updatedObj) => {
        setSelectedAddress(updatedObj);
    };

    const onRadiusChange = (radius) => {
        setRadius(radius);
    };

    useEffect(() => {
        fetch('/cd/feeds/finder/clinics/services/'+services)
        .then(response => response.json())
        .then(data => {
            setClinicData(data);
        })
        .catch(error => {
            alert('There has been an error fetching clinic data')
        });
    }, []);

    return (
        <APIProvider apiKey={apiKey}>
            <div className="title-block">
                <img src="/wp-content/themes/bedrock-theme/static/icons/map-pin.svg" alt="icon" />
                <span>Find your clinic</span>
            </div>
            <SearchField
                onSelectAddress={onSelectAddress}
                onRadiusChange={onRadiusChange}
                defaultAddressValue={defaultAddressValue}
                defaultRadiusValue={defaultRadiusValue}
            />
            {clinicData && (
                <SearchResults previouslySelectedClinic={selectedClinic}  selectedAddress={selectedAddress} radius={radius} clinicData={clinicData} />
            )}
        </APIProvider>
    );
}